import { LayoutProps, VerticalLayout } from '@jsonforms/core';
import { LayoutRenderer } from '@components/uploadForm/renderers/views/layouts/LayoutRenderer';
import { LayoutRendererProps } from '@components/uploadForm/renderers/views/layouts/GroupLayout';
import { getTopPropertyFromElements } from '@components/uploadForm/helpers/getTopPropertyFromElements';

export const VerticalLayoutRenderer = ({
  uischema,
  schema,
  path,
  enabled,
  visible,
  renderers,
  cells,
}: LayoutProps) => {
  const verticalLayout = uischema as VerticalLayout & { label?: string };

  // `stacked` variant: title on top, members as a row-major grid (vs the default
  // label-left column). `variant` may gain other values later.
  const stacked = verticalLayout?.options?.variant === 'stacked';

  const childProps: LayoutRendererProps = {
    elements: verticalLayout.elements,
    schema,
    path,
    enabled,
    direction: 'column',
    visible,
  };

  const topProperty = getTopPropertyFromElements(verticalLayout.elements);
  const requiredList = schema.required ?? [];
  const isRequired = !!(topProperty && requiredList.includes(topProperty));

  return (
    <div
      className={
        stacked
          ? 'flex w-full flex-col border-b border-brightGray py-4 pl-1.5'
          : 'flex justify-between flex-nowrap w-full border-b border-brightGray'
      }
    >
      {verticalLayout.label && (
        <h3
          className={
            stacked
              ? 'pb-2 text-1424 font-semibold'
              : 'min-w-[46%] text-nowrap mt-4 ml-2 font-semibold text-1424'
          }
        >
          {verticalLayout.label}
          <span className='text-redOrange'>{isRequired && ' *'}</span>
        </h3>
      )}
      <LayoutRenderer
        {...childProps}
        className={stacked ? 'grid grid-cols-2 gap-x-4' : ''}
        renderers={renderers}
        cells={cells}
      />
    </div>
  );
};
